import {
  ACCOUNT_STATUSES,
  CUSTOMER_CONTRACT_ROLES,
  NEXT_PAYMENT_OPTIONS,
  PAYMENT_RESTRICTIONS
} from "../../../lib/constants";
import { CriteriaOption } from "../../../types/bulkEmails/CriteriaOption";
import { CriteriaRowModel } from "../../../types/bulkEmails/CriteriaRowModel";
import EXTERNAL_USER_CONTRACT_ROLES from "../../../types/enums/ExternalUserContractRole";
import { AccountNumberCriteriaSelect } from "../components/Criteria/AccountNumberCriteriaSelect";
import { DefaultCriteriaMultipleValueSelect } from "../components/Criteria/DefaultCriteriaMultipleValueSelect";
import { ImpoundTypesCriteriaSelect } from "../components/Criteria/ImpoundTypesCriteriaSelect";
import { useMemo } from "react";

export const useCriteriaOptions = () => {
  const requiredRules = useMemo(() => [{ required: true, message: "Please select at least one option" }], []);

  const options: CriteriaOption[] = useMemo(
    () => [
      {
        key: "status",
        title: "Account Status",
        formKey: ["criteria", "statusesFilter"],
        render: (props) => (
          <DefaultCriteriaMultipleValueSelect {...props} options={ACCOUNT_STATUSES} rules={requiredRules} />
        )
      },
      {
        key: "role",
        title: "Role",
        formKey: ["criteria", "recipientTypesFilter"],
        render: (props) => (
          <DefaultCriteriaMultipleValueSelect {...props} options={CUSTOMER_CONTRACT_ROLES} rules={requiredRules} />
        )
      },
      {
        key: "accountNumber",
        title: "Account Number",
        formKey: ["criteria", "contractNumbersFilter"],
        render: (props) => <AccountNumberCriteriaSelect {...props} />
      },
      {
        key: "nextPayment",
        title: "Next Payment",
        formKey: ["criteria", "nextPaymentDatesFilter"],
        render: (props) => (
          <DefaultCriteriaMultipleValueSelect {...props} options={NEXT_PAYMENT_OPTIONS.filter((x) => x.value !== 0)} />
        )
      },
      {
        key: "impoundType",
        title: "Impound Type",
        formKey: ["criteria", "impoundTypesFilter"],
        render: (props) => <ImpoundTypesCriteriaSelect {...props} />
      },
      {
        key: "paymentRestrictions",
        title: "Payment Restrictions",
        formKey: ["criteria", "paymentRestrictionsFilter"],
        render: (props: any) => <DefaultCriteriaMultipleValueSelect {...props} options={PAYMENT_RESTRICTIONS} />
      }
    ],
    [requiredRules]
  );

  const defaultCriteria: Omit<CriteriaRowModel, "id">[] = useMemo(
    () => [
      {
        optionKey: "status",
        value: [ACCOUNT_STATUSES.find((x) => x.label === "Open")?.value],
        removable: false
      },
      {
        optionKey: "role",
        value: [EXTERNAL_USER_CONTRACT_ROLES.PrimaryBuyer, EXTERNAL_USER_CONTRACT_ROLES.PrimarySeller],
        removable: false
      }
    ],
    []
  );

  return { options, defaultCriteria };
};
